import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { FMS } from 'actions/fms';

const INITIAL_STATE = Immutable({
  loading: false,
  initialized: false,
  data: null,
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${FMS}_LOADING`:
      return state.merge({ loading: true, error: null });
    case FMS:
      return state.merge({
        loading: false,
        initialized: true,
        data: action.payload,
        error: null,
      });
    case `${FMS}_ERROR`:
      return state.merge({
        loading: false,
        initialized: true,
        data: null,
        error: action.payload,
      });
    default:
      return state;
  }
};
